export const AGG = {
  SUM: 'SUM',
  AVG: 'AVG',
  COUNT: 'COUNT'
};